<div class="modal fade" id="pdf-comments" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-lg">
      <div class="modal-header rounded-lg">
        <h5 class="modal-title"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fal fa-times"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <p class="font-weight-bold">Please enter the dates you would like printed.</p>
        <form [formGroup]="pdfForm">
          <div class="d-flex">
            <div class="form-group date-range-input">
              <label>From</label>
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control datepicker"
                  placeholder="Enter Date"
                  tabindex="1"
                  formControlName="startDate"
                  #start_date
                  id="start_date"
                  mask="XX/XX/XXXX"
                  autocomplete="off"
                  (blur)="setData('startDate', start_date.value)" />
                <div class="input-group-append">
                  <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                </div>
                <!-- <span class="error"
                        ngIf="jobDetailForm.get('start_date').hasError('required') && jobDetailForm.get('start_date').touched">
                        Please provide start date
                      </span> -->
              </div>
            </div>
            <div class="form-group date-range-input">
              <label>To</label>
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control datepicker"
                  placeholder="Enter Date"
                  tabindex="2"
                  #end_date
                  id="end_date"
                  formControlName="endDate"
                  mask="XX/XX/XXXX"
                  autocomplete="off"
                  name="endDate"
                  (blur)="setData('endDate', end_date.value)" />
                <div class="input-group-append">
                  <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body__buttons">
            <button
              class="btn btn-primary"
              data-toggle="modal"
              data-target="#pdf-comments"
              data-dismiss="modal"
              type="button"
              (click)="save()">
              Save PDF
            </button>
            <button
              class="btn btn-outline-primary"
              data-toggle="modal"
              data-target="#pdf-comments"
              data-dismiss="modal"
              type="button">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="messages-pdf-format hide" style="width: 8.5in">
  <table #pdfMarkup class="comments-pdf">
    <tr class="comments-pdf__page-header">
      <td colspan="2">
        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center">
          <div class="comments-pdf__page-header__logo">
            <img src="{{ egan_hub_site_logo }}" alt="Andyegan" id="comments-logo" />
          </div>
          <div style="display: flex; align-items: flex-end; background-color: aquamarine">
            <p style="color: black; background-color: blue">{{ jobNumber }}</p>
            <p style="color: black; background-color: yellow">{{ department }}</p>
          </div>
          <div class="comments-pdf__page-header__project">
            {{ projectName }} - {{ commentType === 'job' ? 'Job' : 'Accounting' }} Comments
          </div>
          <div class="comments-pdf__page-header__page-number"></div>
        </div>
      </td>
    </tr>
    <ng-container *ngFor="let group of messageGroups | keyvalue">
      <tr class="comments-pdf__date">
        <td colspan="2">{{ group.value.date }}</td>
      </tr>
      <tr *ngFor="let message of group.value.messages" class="comments-pdf__message page-break">
        <td class="comments-pdf__message__from">{{ message.sender }}, {{ message.time }}</td>
        <td class="comments-pdf__message__comment">
          {{ message.text }}
        </td>
      </tr>
    </ng-container>
    <tr>
      <td style="visibility: hidden">end of report</td>
    </tr>
  </table>
</div>
